module.exports = __webpack_public_path__ + "img/facebook-icon.d1949896.svg";